module.exports = __webpack_public_path__ + "static/01-7808d4471458e3d5403d89b21eba328f.jpg";